// Smart Assist slides, all gated behind the "ask-knowtex" feature flag so
// users without access never see them (see gatedSlides.js).

// Slides that run inside the Smart Chart window (dashboard_intro, orders
// 17-19), which the tour leaves open for them.
export const SMART_CHART_SMART_ASSIST_STEP_IDS = [
  'smart_assist_intro',
  'smart_assist_capabilities',
  'smart_assist_how_to_use',
];

// Slide that runs inside the review note modal (review_upload).
export const REVIEW_SMART_ASSIST_STEP_ID = 'smart_assist_review';

export const SMART_ASSIST_STEP_IDS = [
  ...SMART_CHART_SMART_ASSIST_STEP_IDS,
  REVIEW_SMART_ASSIST_STEP_ID,
];
